/// <amd-module name="Repos/Views/Settings/Options/RestClient/Policy" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\code\vss-code-web\repos\views\settings\options\genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Policy from "Repos/Common/Contracts/Policy";

export interface IPolicyRestClient extends IVssRestClient {
    /**
     * Create a policy configuration of a given policy type.
     * 
     * @param configuration - The policy configuration to create.
     * @param project - Project ID or project name
     */
    createPolicyConfiguration(configuration: Policy.PolicyConfiguration, project: string): Promise<Policy.PolicyConfiguration>;
    /**
     * Update a policy configuration by its ID.
     * 
     * @param configuration - The policy configuration to update.
     * @param project - Project ID or project name
     * @param configurationId - ID of the existing policy configuration to be updated.
     */
    updatePolicyConfiguration(configuration: Policy.PolicyConfiguration, project: string, configurationId: number): Promise<Policy.PolicyConfiguration>;
}

class PolicyRestClient extends RestClientBase implements IPolicyRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Create a policy configuration of a given policy type.
     * 
     * @param configuration - The policy configuration to create.
     * @param project - Project ID or project name
     */
    public async createPolicyConfiguration(
        configuration: Policy.PolicyConfiguration,
        project: string
        ): Promise<Policy.PolicyConfiguration> {

        return this.beginRequest<Policy.PolicyConfiguration>({
            apiVersion: "5.0-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/policy/Configurations/{configurationId}",
            routeValues: {
                project: project
            },
            body: configuration
        });
    }

    /**
     * Update a policy configuration by its ID.
     * 
     * @param configuration - The policy configuration to update.
     * @param project - Project ID or project name
     * @param configurationId - ID of the existing policy configuration to be updated.
     */
    public async updatePolicyConfiguration(
        configuration: Policy.PolicyConfiguration,
        project: string,
        configurationId: number
        ): Promise<Policy.PolicyConfiguration> {

        return this.beginRequest<Policy.PolicyConfiguration>({
            apiVersion: "5.0-preview.1",
            method: "PUT",
            routeTemplate: "{project}/_apis/policy/Configurations/{configurationId}",
            routeValues: {
                project: project,
                configurationId: configurationId
            },
            body: configuration
        });
    }

}

export const PolicyClientName = "Repos.Settings.Options.Policy.IPolicyRestClient";

export function getPolicyClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IPolicyRestClient {
    return pageContext.getRestClient<IPolicyRestClient>(PolicyClientName, options);
}

RestClients.add(PolicyClientName, { 
    factory: PolicyRestClient,
    options: {
        resourceAreaId: "fb13a388-40dd-4a04-b530-013a739c72ef",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
